import {
  Assignment as AssignmentIcon,
  BarChart as BarChartIcon,
  CalendarMonth as CalendarIcon,
  ContactPhone as ContactPhoneIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
} from "@mui/icons-material";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { UserRoleType } from "../store/services/userService";

export interface NavigationItem {
  text: string;
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  path: string;
  subItems?: NavigationItem[];
  allowedRoles?: UserRoleType[];
  requireAll?: boolean;
}

export const navigationConfig: NavigationItem[] = [
  {
    text: "Dashboard",
    icon: DashboardIcon,
    path: "/dashboard",
    subItems: [
      {
        text: "Översikt",
        icon: DashboardIcon,
        path: "/dashboard",
      },
      {
        text: "Kalender",
        icon: CalendarIcon,
        path: "/calendar",
      },
      {
        text: "Aktiviteter",
        icon: DashboardIcon,
        path: "/activities",
      },
      {
        text: "Ärenden",
        icon: AssignmentIcon,
        path: "/works",
      },
    ],
  },
  {
    text: "Kunder",
    icon: PeopleIcon,
    path: "/customers",
    subItems: [
      {
        text: "Mina kunder",
        icon: PeopleIcon,
        path: "/customers",
      },
      {
        text: "Prospekt/Suspekt",
        icon: PeopleIcon,
        path: "/prospect-suspect",
      },
      {
        text: "Braze data",
        icon: ContactPhoneIcon,
        path: "/my-contacts",
      },
      {
        text: "Mina möjligheter",
        icon: PeopleIcon,
        path: "/my/opportunities",
      },
    ],
  },
  {
    text: "Rapporter",
    icon: BarChartIcon,
    path: "/reports",
    allowedRoles: [
      UserRoleType.Admin,
      UserRoleType.CrmAdmin,
      UserRoleType.SalesAdmin,
      UserRoleType.SalesPerson,
      UserRoleType.ExternalSale,
      UserRoleType.ExternalSaleAdmin,
    ],
    subItems: [
      {
        text: "Säljrapporter",
        icon: BarChartIcon,
        path: "/reports",
        allowedRoles: [
          UserRoleType.Admin,
          UserRoleType.CrmAdmin,
          UserRoleType.SalesAdmin,
          UserRoleType.SalesPerson,
          UserRoleType.ExternalSale,
          UserRoleType.ExternalSaleAdmin,
        ],
      },
      {
        text: "Affärsmöjligheter",
        icon: BarChartIcon,
        path: "/opportunites",
        allowedRoles: [
          UserRoleType.Admin,
          UserRoleType.CrmAdmin,
          UserRoleType.SalesAdmin,
          UserRoleType.SalesPerson,
          UserRoleType.ExternalSale,
          UserRoleType.ExternalSaleAdmin,
        ],
      },
      {
        text: "Aktiviteter",
        icon: BarChartIcon,
        path: "/sales-manager",
        allowedRoles: [
          UserRoleType.Admin,
          UserRoleType.CrmAdmin,
          UserRoleType.SalesAdmin,
          UserRoleType.ExternalSaleAdmin,
        ],
      },
      {
        text: "Säkra Volym",
        icon: BarChartIcon,
        path: "/secure-volume",
      },
    ],
  },

  /*   {
    text: "Inställningar",
    icon: SettingsIcon,
    path: "/settings",
    allowedRoles: [
      UserRoleType.Admin,
      UserRoleType.CrmAdmin,
      UserRoleType.AppAdmin,
    ],
  }, */
];
